import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Player } from '@/types/player';

interface PlayerBreadcrumbProps {
  player: Player | null;
  playerName: string;
}

export const PlayerBreadcrumb = ({ player, playerName }: PlayerBreadcrumbProps) => {
  return (
    <div className="flex items-center gap-2 mb-6 text-sm text-muted-foreground">
      <Link to="/superadmin" className="hover:text-foreground">
        Super Admin
      </Link>
      <ChevronRight className="h-4 w-4" />
      {player?.teams && (
        <>
          <Link 
            to={`/superadmin/org/${player.teams.clubs?.organizations?.id}`}
            className="hover:text-foreground"
          >
            {player.teams.clubs?.organizations?.name}
          </Link>
          <ChevronRight className="h-4 w-4" />
          <Link 
            to={`/superadmin/club/${player.teams.clubs?.id}`}
            className="hover:text-foreground"
          >
            {player.teams.clubs?.name}
          </Link>
          <ChevronRight className="h-4 w-4" />
          <Link 
            to={`/superadmin/team/${player.teams.id}`}
            className="hover:text-foreground"
          >
            {player.teams.name}
          </Link>
          <ChevronRight className="h-4 w-4" />
        </>
      )}
      <span className="text-foreground">{playerName}</span>
    </div>
  );
};